export default __webpack_public_path__ + "static/media/BLACKIP_Dashboard.ca85a731.svg";